import React, { useState, useEffect } from 'react';
import { Alert } from '../../../styles/components';
import { CheckCircleIcon, KeyIcon } from '@heroicons/react/24/outline';

interface KeypairStepProps {
  clientId: string;
  providerName?: string;
  isGenerating?: boolean;
  onGenerate: () => void;
  isGenerated: boolean;
}

export function KeypairStep({ 
  clientId,
  providerName,
  isGenerating = false,
  onGenerate,
  isGenerated
}: KeypairStepProps) {
  const [autoGenerateAttempted, setAutoGenerateAttempted] = useState(false);

  useEffect(() => {
    if (!autoGenerateAttempted && !isGenerated && clientId) {
      setAutoGenerateAttempted(true);
      onGenerate();
    }
  }, [clientId, autoGenerateAttempted, isGenerated, onGenerate]);

  return (
    <>
      <div style={{ 
        marginBottom: '1.5rem', 
        padding: '1rem', 
        backgroundColor: '#f3f4f6', 
        borderRadius: '0.5rem' 
      }}>
        <p style={{ margin: 0, color: '#374151', fontSize: '0.875rem' }}>
          A secure RSA key pair will be generated for {providerName || 'the card processor'} integration.
        </p>
      </div>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '2rem',
        backgroundColor: '#f9fafb',
        borderRadius: '0.5rem',
        border: '2px solid #e5e7eb'
      }}>
        {isGenerating ? (
          <>
            <KeyIcon style={{ width: '3rem', height: '3rem', color: '#6b7280', marginBottom: '1rem' }} />
            <h4 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>Generating Key Pair...</h4>
            <p style={{ margin: 0, color: '#6b7280', fontSize: '0.875rem' }}>
              Please wait while we generate a secure RSA key pair
            </p>
          </>
        ) : isGenerated ? (
          <>
            <CheckCircleIcon style={{ width: '3rem', height: '3rem', color: '#10b981', marginBottom: '1rem' }} />
            <h4 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>Key Pair Generated Successfully</h4>
            <p style={{ margin: 0, color: '#6b7280', fontSize: '0.875rem' }}>
              The RSA key pair has been securely generated and stored
            </p>
          </>
        ) : (
          <>
            <KeyIcon style={{ width: '3rem', height: '3rem', color: '#6b7280', marginBottom: '1rem' }} />
            <h4 style={{ margin: '0 0 0.5rem 0', color: '#374151' }}>Ready to Generate Key Pair</h4>
            <p style={{ margin: 0, color: '#6b7280', fontSize: '0.875rem' }}>
              Click Next to generate the key pair
            </p>
          </>
        )}
      </div>
      
      <Alert variant="info" style={{ marginTop: '1rem' }}>
        <strong>Note:</strong> The key pair is generated and stored securely in Azure Key Vault. 
        The private key never leaves the secure environment.
      </Alert>
    </>
  );
}